module.exports = __webpack_public_path__ + "img/sk.7af1b1d8.svg";